import { render, staticRenderFns } from "./DepotHeader.vue?vue&type=template&id=c6d84002&scoped=true&"
import script from "./DepotHeader.vue?vue&type=script&lang=ts&"
export * from "./DepotHeader.vue?vue&type=script&lang=ts&"
import style0 from "./DepotHeader.vue?vue&type=style&index=0&id=c6d84002&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6d84002",
  null
  
)

export default component.exports